export default __webpack_public_path__ + "static/media/unlock.f48bd728.svg";